export const LOCATION_HEADER_TRIGGER = 'location-header-trigger';
